module.exports = __webpack_public_path__ + "static/media/ATS-logo-graphic.5f9e9683.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ATS-logo-graphic.png
// module id = 531
// module chunks = 0